import { useNavigate } from 'react-router-dom';

import { useCurrentUser } from '@/hooks/useCurrentUser';
import { RoutePath } from '@/routes/RoutePath';
import { generatePathWithDomain } from '@/utils/generatePathWithDomain';

export function useOpenNotificationPreferences(onNavigate?: () => void) {
  const navigate = useNavigate();
  const { data: currentUser } = useCurrentUser();

  return () => {
    if (!currentUser) {
      return;
    }
    onNavigate?.();
    navigate(
      generatePathWithDomain(RoutePath.StaffNotificationPreferences, {
        staff_id: currentUser.id
      })
    );
  };
}
